import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { boardingFormService, merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseCheckIfDocumentExistsMutationParams = {
	id: number | string;
	errorLink?: string;
};

const useCheckIfDocumentExistsMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseCheckIfDocumentExistsMutationParams) =>
			boardingFormService.isCheckMpaDocument(id),
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess(result, { id, errorLink }) {
				if (result) {
					merchantInfoService.viewFullAppDocument(id);
				} else {
					window.open(errorLink, "_blank");
				}
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useCheckIfDocumentExistsMutation;
